import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/search/page.tsx");
